import {Responses} from 'commonTypes/users'
import {axiosInstance} from './getInstance'

export const iAm = async (): Promise<Responses.IAm> => {
  const response = await axiosInstance.post<Responses.IAm>('/api/iam')
  return response.data
}
